// import axios from "axios";
import * as XLSX from 'xlsx'

export const newDate = (time, type) => {
    var date = new Date(time)
    var yyyy = date.getFullYear()
    var mm = date.getMonth() + 1
    var dd = date.getDate()
    var hh = date.getHours()
    var minute = date.getMinutes()
    var ss = date.getSeconds()
    mm = mm < 10 ? '0' + mm : mm
    dd = dd < 10 ? '0' + dd : dd
    hh = hh < 10 ? '0' + hh : hh
    minute = minute < 10 ? '0' + minute : minute
    ss = ss < 10 ? '0' + ss : ss
    if (type == 0) {
        return yyyy
    } else if (type == 1) {
        return yyyy + '-' + mm
    } else if (type == 2) {
        return yyyy + '-' + mm + '-' + dd
    } else {
        return yyyy + '-' + mm + '-' + dd + ' ' + hh + ':' + minute + ':' + ss
    }
}

/**
 * @description: 根据传入值获取上周第一天和最后一天
 * @param {*}  n:  7(上周第一天) 1(上周最后一天) 0(本周第一天) -6(本周最后一天)
 * @Author: 
 * @return 毫秒数
 */
export const getLastWeek = (n) => {
    var now = new Date();
    var year = now.getFullYear();
    var month = now.getMonth() + 1; //因为月份是从0开始的,所以获取这个月的月份数要加1才行
    var date = now.getDate();
    var day = now.getDay();
    //判断是否为周日,如果不是的话,就让今天的day-1(例如星期二就是2-1)
    if (day !== 0) {
        n = n + (day - 1);
    } else {
        n = n + day;
    }
    if (day) {
        //这个判断是为了解决跨年的问题
        if (month > 1) {
            month = month;
        } else { //这个判断是为了解决跨年的问题,月份是从0开始的
            year = year - 1;
            month = 12;
        }
    }
    now.setDate(now.getDate() - n);
    year = now.getFullYear();
    month = now.getMonth() + 1;
    date = now.getDate();
    var s = year + "-" + (month < 10 ? ('0' + month) : month) + "-" + (date < 10 ? ('0' + date) : date) +
        " 00:00:00";
    return new Date(s).getTime();
}

/**
 * @description: 根据某一天获取本月的第一天及最后一天（不传默认为本月第一天）
 * @param {*}  timestamp:  某天时间
 * @Author: 
 * @return 毫秒数
 */
export function getMonthFrist(timestamp) {
    let date = timestamp ? new Date(timestamp) : new Date()
    let year = date.getFullYear()
    let month = date.getMonth()
    return new Date(year, month, 1) * 1
}
export function getMonthLast(timestamp) {
    let date = timestamp ? new Date(timestamp) : new Date()
    let year = date.getFullYear()
    let month = date.getMonth()
        // day为0表示获取上一个月最后一天，所以month+1
        // 86300表示一天秒数，最后日期为 23:59:59
    return (new Date(year, month + 1, 0) / 1000 + 86399) * 1000
}
export function getAcademicYearRange() {
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth(); // 0-11(Jan-Dec)

    // 判断是否在6月1日之后（含6月1日）
    const isAfterJune = currentMonth > 5 || (currentMonth === 5 && now.getDate() >= 1);

    // 计算起始年份
    const startYear = isAfterJune ? currentYear : currentYear - 1;

    // 创建起始时间(当年或前一年的6月1日 00:00:00.000)
    const start = new Date(startYear, 5, 1);
    start.setHours(0, 0, 0, 0);

    // 结束时间始终为前一天
    const end = now.setTime(now.getTime() - 3600 * 1000 * 24 * 1)

    return [start, end];
}
export const downloadFile = (url, name) => {
    var link = document.createElement('a');
    link.download = name;
    // link.href = import.meta.env.VITE_BASE_API+'/webnpdp'+url;
    link.href = '/webnpdp' + url;
    link.click();
}

export const setCookie = (name, value, iDay) => {
    var oDate = new Date();
    oDate.setDate(oDate.getDate() + iDay);
    value = encodeURIComponent(value);
    document.cookie = name + '=' + value + ';expires=' + oDate + ';path=/;domain=;';
}

export const getCookie = (name) => {
    var arr = document.cookie.split('; ');
    var i = 0;
    for (i = 0; i < arr.length; i++) {
        var arr2 = arr[i].split('=');
        if (arr2[0] == name) {
            return arr2[1];
        }
    }
    return ''; //如果没有就返回空值
}

export const delCookie = (name) => {
    setCookie(name, '', -1);
}

export const setTableRowStyle = ({
    row,
    rowIndex
}) => {
    if (rowIndex == 0) {
        console.log(row, rowIndex)
        return 'color:#0FAD8B;font-size:14px;font-weight:bold;'
    } else {
        return 'color:#595959;'
    }
}
export const setTableChildren = (data) => {
    let options = JSON.parse(JSON.stringify(data)).map(item => { // 展示数据
        // hasChildren 表示需要展示一个箭头图标
        item.hasChildren = item.children && item.children.length > 0
            // 只展示一层
            // 如果有children数据，会自动加载，就不是懒加载了，也可以配置tree-props里面的children为其他字段
        item.children = null
            // 记住层级关系
        item.idList = [item.id]
        return item
    })
    return options
}

export const loadTable = (tree, treeNode, resolve, dataCopy) => {
    // 层级关系备份
    const idCopy = JSON.parse(JSON.stringify(tree.idList))

    // 查找下一层数据
    let resolveArr = dataCopy
    let id
        // eslint-disable-next-line
    while (id = tree.idList.shift()) {
        const tarItem = resolveArr.find(item => item.id === id)
        tarItem.loadedChildren = true
        resolveArr = tarItem.children
    }

    // 处理下一层数据的属性
    resolveArr = JSON.parse(JSON.stringify(resolveArr))
    resolveArr.forEach(item => {
        item.hasChildren = item.children && item.children.length > 0
        item.children = null
            // 此处需要深拷贝，以防各个item的idList混乱
        item.idList = JSON.parse(JSON.stringify(idCopy))
        item.idList.push(item.id)
    })

    // 标识已经加载子节点
    tree.loadedChildren = true

    setTimeout(() => {
        // 渲染子节点
        resolve(resolveArr)
    }, 50)
}

export const getUrlParam = (name) => {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return decodeURI(r[2]);
    return null; //返回参数值  (decodeURI解决参数乱码问题)
}

export const proxyArray = (arr) => {
    let newArr = []
    if (Array.isArray(arr) && Object.prototype.hasOwnProperty.call(arr, '[[IsRevoked]]')) {
        newArr = Array.apply(null, arr)
    } else {
        newArr = arr
    }
    return newArr
}

export const isProxyArray = (arr) => {
    return Array.isArray(arr) && Object.prototype.hasOwnProperty.call(arr, '[[IsRevoked]]');
}

export const deepCopy = (obj) => {
    return JSON.parse(JSON.stringify(obj));
}

export const downloadExcel = (excelData) => {
    // 创建工作簿
    const workbook = XLSX.utils.book_new();
    // 创建工作表 + 将工作表添加到工作簿
    excelData.data.forEach((v, i) => {
            // let data = JSON.stringify(v.data))
            // data = data.replace(/title/g, '标题');
            // data = data.replace(/yoy/g, '同比');
            // data = data.replace(/mom/g, '环比');
            // data = data.replace(/value/g, '值');
            // data = data.replace(/unit/g, '单位');
            // JSON.parse(data)
            XLSX.utils.book_append_sheet(workbook, XLSX.utils.json_to_sheet(v.data), v.title);
        })
        // 将工作簿保存为Blob对象  
    const blob = new Blob([XLSX.write(workbook, {
        bookType: 'xlsx',
        type: 'array'
    })], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
    // 创建下载链接并触发下载操作  
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = excelData.name; // 设置下载文件的文件名  
    document.body.appendChild(link);
    link.click(); // 触发下载操作  
    document.body.removeChild(link);
}